export class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
    };

    this.onItemClick = this.onItemClick.bind(this);
    // Delegated: the country list is only rendered while its modal is open
    this.addEventListener('click', this.onItemClick);
  }

  onItemClick(event) {
    const item = event.target.closest('button[data-value]');
    if (!item) return;

    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = item.dataset.value;
    if (form) form.submit();
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}